import { callExternalApi } from './external-api.service'
import API_PATHS from '../constants/API_PATHS'

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL

export const svc_createAccount = async (accessToken, userId, account) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_ACCOUNT(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: account,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_createDebtAccount = async (accessToken, userId, debtAccount) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_DEBT_ACCOUNT(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: debtAccount,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getAccount = async (accessToken, userId, accountId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_ACCOUNT(userId, accountId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getAccounts = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_ACCOUNTS(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getAccountsGroupedByType = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_ACCOUNTS_GROUPED_BY_TYPE(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getDebtAccount = async (accessToken, userId, debtAccountId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_DEBT_ACCOUNT(userId, debtAccountId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getDebtAccounts = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_DEBT_ACCOUNTS(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getIncludedAccountBalances = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_INCLUDED_ACCOUNT_BALANCES(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateAccount = async (accessToken, userId, account) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_ACCOUNT(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: account,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateDebtAccount = async (accessToken, userId, account) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_DEBT_ACCOUNT(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: account,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteAccount = async (accessToken, userId, accountId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_ACCOUNT(userId, accountId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}
